import { PostDadosPessoaisRequest } from '@services/postDadosPessoaisService'

/**
 * Actions Types
 */

export enum DadosPessoaisTypes {
  SET_USER_NAME_DADOS_PESSOAIS = '@refinanciamento/dadosPessoais/SET_USER_NAME_DADOS_PESSOAIS',
  SET_CPF_DADOS_PESSOAIS = '@refinanciamento/dadosPessoais/SET_CPF_DADOS_PESSOAIS',
  SET_DATA_NASCIMENTO = '@refinanciamento/dadosPessoais/SET_DATA_NASCIMENTO',
  SET_CONTA_DADOS_PESSOAIS = '@refinanciamento/dadosPessoais/SET_CONTA_DADOS_PESSOAIS',
  POST_DADOS_PESSOAIS_REQUEST = '@refinanciamento/dadosPessoais/POST_DADOS_PESSOAIS_REQUEST',

  GET_DADOS_PESSOAIS_REQUEST = '@refinanciamento/dadosPessoais/GET_DADOS_PESSOAIS_REQUEST',
  GET_DADOS_PESSOAIS_SUCCESS = '@refinanciamento/dadosPessoais/GET_DADOS_PESSOAIS_SUCCESS',
  GET_DADOS_PESSOAIS_ERROR = '@refinanciamento/dadosPessoais/GET_DADOS_PESSOAIS_ERROR',
  RESET_DADOS_PESSOAIS_LOADING = '@refinanciamento/dadosPessoais/RESET_DADOS_PESSOAIS_LOADING',
  SET_HAS_ENDERECO = '@refinanciamento/dadosPessoais/SET_HAS_ENDERECO',
  SET_HAS_DADOS_BANCARIOS = '@refinanciamento/dadosPessoais/SET_HAS_DADOS_BANCARIOS',
  SET_IS_VALID_MODALITY_ACCOUNT = '@refinanciamento/dadosPessoais/SET_IS_VALID_MODALITY_ACCOUNT',
  SET_POST_DADOS_PESSOAIS_LOADING = '@refinanciamento/dadosPessoais/SET_POST_DADOS_PESSOAIS_LOADING',
  SET_BANK_ACCOUNT_CORRECTION_MODE = '@refinanciamento/dadosPessoais/SET_BANK_ACCOUNT_CORRECTION_MODE',
  SET_REJECTED_BANK_ACCOUNT = '@refinanciamento/dadosPessoais/SET_REJECTED_BANK_ACCOUNT',
  CLEAR_BANK_ACCOUNT_CORRECTION = '@refinanciamento/dadosPessoais/CLEAR_BANK_ACCOUNT_CORRECTION',
}

/**
 * State Type
 */

export interface DadosPessoaisState {
  readonly userNameDadosPessoais: string | undefined
  readonly cpfDadosPessoais: string | undefined
  readonly dataNascimento: string
  readonly contaDadosPessoais: string
  readonly loading: boolean
  readonly postDadosPessoaisLoading: boolean
  readonly hasEndereco?: boolean
  readonly hasDadosBancarios?: boolean
  readonly isValidModalityAccount: boolean | null
  readonly correctionMode: boolean
  readonly rejectedBankAccount: RejectedBankAccount | null
}

export type RejectedBankAccount = PostDadosPessoaisRequest['bankData']

export type PostDadosPessoaisPayload = {
  callback?: () => void
  errorCallback?: () => void
  invalidModalityAccountCallback?: () => void
}

export type GetDadosPessoaisPayload = {
  callbackError?: () => void
  callback: () => void
}

export type GetDadosPessoaisSagaPayload = {
  type: string
  payload: GetDadosPessoaisPayload
}

export interface GetDadosPessoaisResponse {
  isBankAccountEditable: boolean
  isValidModalityAccount?: boolean | null
  addressData?: AddressData | null
  bankData?: BankData | null
}

export interface AddressData {
  zipCode: string
  addressType: string
  streetAddress: string
  number: string
  additionalInfo?: string
  district: string
  state: string
  city: string
}

export interface BankData {
  bankCode: string
  bankName: string
  accountType: string
  bankBranch: string
  accountNumber: string
  accountDigit: string
}
